import { gql } from 'graphql-tag';

const specificResourceAllocationUserFragment = gql`
  fragment SpecificResourceAllocationUser on ResourceAllocationUser {
    userAllocationId
    userUri
    user {
      slug
      displayText
      uri
      permittedActionUris
      roles {
        projectRole {
          uri
          name
        }
        isPrimary
      }
    }
    costRate
    primaryRoleCostRate
    primaryRoleCostCurrencyUri
    primaryRoleCostCurrency {
      id
      displayText
    }
    costCurrencyUri
    costCurrency {
      id
      displayText
    }
  }
`;

export const specificResourceAllocationUser2Fragment = gql`
  fragment SpecificResourceAllocationUser2 on ResourceAllocationUser {
    userAllocationId
    userUri
    user {
      slug
      displayText
      uri
      permittedActionUris @include(if: $includeUserPermittedActions)
      roles @include(if: $includeUserRoles) {
        projectRole {
          uri
          name
        }
        isPrimary
      }
    }
    costRate
    primaryRoleCostRate
    primaryRoleCostCurrencyUri
    primaryRoleCostCurrency {
      id
      displayText
    }
    costCurrencyUri
    costCurrency {
      id
      displayText
    }
  }
`;

export default specificResourceAllocationUserFragment;
